<template>
  <div
    class="drawer-menu"
    :class="{
      hidden: !visible
    }"
  >
    <div class="drawer-menu__model" :class="{'drawer-menu__model--dark': cartStyle == 'dark' }" @click.prevent="() => $emit('close', $event)" v-if="visible">

    </div>
    <div class="drawer-menu__body titlemenulist" :class="{'titlemenulist--dark': cartStyle == 'dark' }">
      <div class="titlemenulist-head">
        <a
          href="/"
          class="iconfont icon-cm-cancel-1-copy"
          @click.prevent="() => $emit('close', $event)"
        />
      </div>
      <ul class="secondary_title">
        <!-- 主菜单栏 -->
        <li v-for="item in menus" :key="'titlemenulist' + item.ID" class="titlemainmenu">
          <div>
            <a class="secondary_title" :href="item.path || item.url" @click.stop>{{ item.title }}</a>
            <button
              v-if="item.children && item.children.length"
              class="iconfont icon-jia"
              @click.stop="secendMenuSwitch"
            ></button>
          </div>
          <ul v-if="item.children && item.children.length" class="secend_menu_ul">
            <li v-for="subitem in item.children" :key="subitem.Id" class="titlemainmenu has_secend_menu">
              <div>
                <a class="secondary_title" :href="subitem.path || subitem.url" @click.stop>{{ subitem.title }}</a>
                <button
                  v-if="subitem.children.length"
                  class="iconfont icon-jia"
                  @click.stop="secendMenuSwitch"
                ></button>
              </div>
              <ul v-if="subitem.children.length" class="secend_menu_ul">
                <li
                  v-for="childrensubitem in subitem.children"
                  :key="childrensubitem.Id"
                  class="titlemainmenu has_secend_menu has_third_menu"
                >
                  <div>
                    <a class="secondary_title" :href="childrensubitem.path || childrensubitem.url" @click.stop>
                      {{ childrensubitem.title }}
                    </a>
                  </div>
                </li>
              </ul>
            </li>
          </ul>
        </li>
        <!-- 登陆注册 -->
        <li class="titlemenulist-login" v-if="checkoutMemberConfig != 'guest'">
          <!-- 登录状态 -->
          <div v-if="loginStatus">
            <a class="secondary_title" href="/account">{{ $t('account.my_account') }}</a>
            <form id="logout-form" action="/logout" method="POST">
              <input type="hidden" name="_token" :value="token" />
              <a class="secondary_title" href="/" @click.prevent="logout">{{ $t('account.log_out') }}</a>
            </form>
          </div>
          <div v-else>
            <a class="secondary_title" href="/account/login">{{ $t('shopping.log_in') }}</a>
            <a class="secondary_title" href="/account/register">{{ $t('login.create_account') }}</a>
          </div>
          <div></div>
        </li>

        <!-- 副菜单栏 -->
        <li v-for="item in secondaryMenu" :key="item.ID">
          <a class="secondary_title" :href="item.path || item.url" @click.stop>{{ item.title }}</a>
        </li>
      </ul>
      <!-- 移动端：货币切换 -->
      <div class="menu-currency-selector-mb" v-if="showCurrencySelector && currencySelectorType == 'menu'">
        <v-selectprice model="default" :noprice="true" :append-to-body="false"></v-selectprice>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'DrawerMenu',
  props: {
    menus: {
      type: Array,
      default: [],
    },
    // 登录状态
    loginStatus: {
      type: Boolean,
      default: false,
    },
    secondaryMenu: {
      type: Array,
      default: []
    },
    visible: {
      type: Boolean,
      default: false
    },
    // 是否挂载到body下
    appendToBody: {
      type: Boolean,
      default: false
    },
    cartStyle: ''
  },
  emits: ['close'],
  data() {
    return {
      token: document.head.querySelector('meta[name="csrf-token"]').content
    }
  },
  computed: {
    ...mapState({
      checkoutMemberConfig: ({ options }) => options.base?.checkout_member_config,
      showCurrencySelector: ({ options }) => options.theme?.global?.show_currency_selector,
      currencySelectorType: ({ options }) => options?.theme?.global?.currency_selector_type,
    }),
  },
  mounted() {
    // 挂载到body下面
    if (this.appendToBody) {
      const node = this.$mount().$el;
      document.body.appendChild(node);
    }
  },
  methods: {
    secendMenuSwitch(e) {
      if (e.target.className.includes('icon-jian')) {
        this.$(e.target).removeClass('icon-jian')
        this.$(e.target).addClass('icon-jia')
      } else {
        this.$(e.target).removeClass('icon-jia')
        this.$(e.target).addClass('icon-jian')
      }
      this.$(e.target.parentNode.nextElementSibling).slideToggle(300)
    },
    logout() {
      document.getElementById('logout-form').submit()
    },
  },
}
</script>

<style lang="scss" scoped>
.drawer-menu {
  position: fixed;
  z-index: 1031;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  transition: left 0.2s;
  &.hidden {
    left: -100vw;
  }

  &__model {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    z-index: 1;
    left: 0;
    &--dark{
      background-color: #0000001f;
    }
  }
  &__body {
    position: absolute;
    z-index: 2;
    height: 100%;
    width: 290px;
    top: 0;
    left: 0;
  }
  .titlemenulist {
    overflow: auto;
    padding-top: 0px;
    background: #F7F7F7;
    padding-bottom: 20px;
    .titlemenulist-head {
      padding: 14px 20px;
      text-align: right;
      a {
        color: #C0C0C0;
        text-decoration: none;
        font-weight: 600;
      }
    }
    ul {
      width: 100%;
      padding: 0;
      .titlemainmenu {
        position: relative;
        list-style: none;
        div {
          display: flex;
          justify-content: space-between;
          align-items: center;
          position: relative;
          a {
            flex: 1;
            padding: 10px 20px;
            font-size: 16px;
            line-height: 24px;
          }
          button {
            padding: 10px 20px;
            border: none;
            background: transparent;
          }
        }
        &:not(.has_secend_menu)>div:after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 20px;
          right: 20px;
          border-bottom: 1px solid rgba(34, 35, 35, 0.1);
        }
      }
      .secend_menu_ul {
        display: none;
        &::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 20px;
          right: 20px;
          border-bottom: 1px solid rgba(34, 35, 35, 0.1);
        }
        .has_secend_menu {
          div {
            a {
              //padding-left: 30px;
              color: rgba(33, 37, 41, 0.7);
            }
          }
        }
      }

      li {
        width: 100%;
        box-sizing: border-box;
        text-align: left;
        a {
          width: 100%;
          display: inline-block;
          padding: 10px 20px;
          line-height: 24px;
          text-decoration: none;
          font-size: 16px;
          color: #212529;
        }
      }
      .titlemenulist-login {
        & > div > a {
          position: relative;
          &::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 20px;
            right: 20px;
            border-bottom: 1px solid rgba(34, 35, 35, 0.1);
          }
        }
      }
    }
    &--dark{
      overflow: inherit !important;
      background-color: #000;
      >ul{
        overflow-y: auto;
        height: calc(100% - 53px);
        &::-webkit-scrollbar {
          width: 14px;
          background-color: #fff;
        }
        &::-webkit-scrollbar-track-piece{
          background-color: #0e0e0e;
        }
        &::-webkit-scrollbar-thumb{
          background-color: #3e3e3e;
        }
      }
      li{
        a{
          color: #ccc !important;
        }
      }
      .titlemainmenu{
        a{
          color: #fff !important;
        }
        button{
          color: #fff !important;
        }
      }
      &::v-deep {
        .menu-currency-selector-mb{
          background-color: #000;
          .selectpricewrap{
            >div>div{
              >span{
                color: #fff;
              }
              .pricelist{
                background-color: #000;
                &::-webkit-scrollbar {
                  width: 14px;
                  background-color: #fff;
                }
                &::-webkit-scrollbar-track-piece{
                  background-color: #0e0e0e;
                }
                &::-webkit-scrollbar-thumb{
                  background-color: #3e3e3e;
                }
                >.clearfix{
                  .secondary_title{
                    color: #fff !important;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  @media screen and (max-width: 767px) {
    .titlemenulist {
      padding-bottom: 50px;
      ul {
        li.titlemainmenu {
          a {
            width: calc(100% - 20px);
            padding-right: 40px !important;
            white-space: nowrap;
            overflow: hidden;
            text-overflow:ellipsis;
          }
          button {
            position: absolute;
            width: unset;
            right: 0;
            text-align: right;
            padding: 12px 15px !important;
          }
        }
      }
      &--dark {
        >ul{
          &::-webkit-scrollbar {
            width: 4px;
          }
        }
        &::v-deep {
          .menu-currency-selector-mb{
            background-color: #000;
            .selectpricewrap{
              >div>div{
                .pricelist{
                  &::-webkit-scrollbar {
                    width: 3px;
                  }
                }
              }
            }
          } 
        }
      }
    }
  }
}
.menu-currency-selector-mb {
  display: flex;
  position: fixed;
  bottom: 0;
  width: 290px;
  background-color: #f2f2f2;
  padding: 0 15px;
  ::v-deep { 
    .selectpricewrap {
      line-height: 52px;
      width: 100%;
      .secondary_title {
          color: #3a3a3a !important;
      }          
      .icon-cm-xia {
        float: right;
        transform: rotateZ(180deg);
      }
      .pricelistbox {
        width: 270px !important;
        transform: rotateZ(180deg);
        bottom: 40px;
        left: 0;
        .pricelist {
          transform: rotateZ(180deg);
          width: calc(100% - 10px);
          margin: 0;
          height: 215px;
          overflow: auto;
          overflow-x: hidden;
          padding: 20px 15px  0  15px!important;
          li {
            max-width: 230px !important;
            width: 100% !important;
            margin-left: 0 !important;
            display: block !important;
          }
        }
      }
    }
  }
  &:active {
      background-color: #f9f9f9;
  }
}
</style>
